<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-需求大厅-添加
    -->
    <el-dialog
    title="添加需求大厅"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

       <!-- 新增：关联需求类型下拉列表 -->
      <el-form-item label="关联需求类型" prop="requirement_type_id">
        <el-select 
          v-model="form.requirement_type_id" 
          placeholder="请选择需求类型" 
          class="max-w460"
          clearable
        >
          <el-option 
            v-for="type in requirementTypes" 
            :key="type.requirement_type_id" 
            :label="type.name" 
            :value="type.requirement_type_id"
          ></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="需求信息" prop="name"><el-input v-model="form.name" placeholder="请输入需求大厅名称" class="max-w460"></el-input></el-form-item>
    

    

      <el-form-item label="图片：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.image">
          <transition-group>
            <div v-for="(item, index) in form.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'image')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('image')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>





        <!-- 新增：需求大厅视频（与图片上传方式一致） -->
      <el-form-item label="视频：" prop="model.video">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.video">
          <transition-group>
            <div v-for="(item, index) in form.video" :key="item.file_path">
              <div class="item">
                <!-- 视频预览：用video标签，默认显示第一帧作为封面 -->
                <video 
                  :src="item.file_path" 
                  alt="video_path" 
                  controls 
                  preload="metadata" 
                  style="max-width:100%;max-height:100%;object-fit:contain;"
                ></video>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'video')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('video')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

      <el-form-item label="需求描述">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  
      
      <el-form-item label="完成标准" >
        <el-input 
          v-model="form.standard" 
          placeholder="请详细描述任务完成标准" 
          class="max-w460"
        ></el-input>
      </el-form-item>  

     <!-- 新增：预算金额（匹配数据库 budget_amount） -->
      <el-form-item label="预算金额" prop="budget_amount">
        <el-input 
          v-model="form.budget_amount" 
          placeholder="请输入预算金额（如：10000.00）" 
          class="max-w460"
          type="number"
          step="0.01"
        ></el-input>
      </el-form-item>
           <!-- 新增：预算金额（匹配数据库 budget_amount） -->
      <el-form-item label="保证金" prop="budget_deposit">
        <el-input 
          v-model="form.budget_deposit" 
          placeholder="请输入保证金（如：10000.00）" 
          class="max-w460"
          type="number"
          step="0.01"
        ></el-input>
      </el-form-item>
      <!-- 新增：联系方式（匹配数据库 contact_information） -->
      <el-form-item label="联系方式" prop="contact_information">
        <el-input 
          v-model="form.contact_information" 
          placeholder="请输入联系方式（如：电话/微信/邮箱）" 
          class="max-w460"
        ></el-input>
      </el-form-item>   


            <!-- 新增：区域位置相关字段（适配数据库字段） -->
      <el-form-item label="详细地址" prop="address">
      <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
          </el-col>
        </el-row>

      </el-form-item>



       <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片 -->
     <!-- </Upload> --> 
      <Upload v-if="isProductUpload" :config="uploadConfig" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传{{ uploadTypeText }}</Upload>

    
    </div>
</el-dialog>
  
</template>

<script>
import Requirement_hallApi from '@/api/requirement_hall.js';
import Requirement_typeApi from '@/api/requirement_type.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Getpoint from '@/components/map/Getpoint.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     draggable,
     Uediter,
     Getpoint
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
         isImg: false,  
         /*富文本配置*/
         ueditor: {
         text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
       /* 需求类型列表数据 */
      requirementTypes: [],
      /* 新增：上传配置（区分图片/视频的格式和数量限制） */
      uploadConfig: { total: 3, accept: 'image/*' }, // 默认图片配置
      uploadTypeText: '图片', // 上传弹窗标题文本
      /*form表单数据 - 新增video数组存储视频数据*/
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        // categorya:{},
        sort:50,
        intro:"",
        video: [],
        longitude: '', 
        latitude: '', 
        detailed_address: '', 
        completion_date: '',
        budget_amount: '', // 预算金额
        budget_deposit:'',//保证金金额
        contact_information: '', // 联系方式
        requirement_typhonee_id: null, // 关联需求类型ID
        detail:"",//详细地址
        coordinate:"",//坐标
      },
      loading: false,
      /*验证规则*/
      rules: {
        requirement_type_id: [{ required: true, message: '请选择关联需求类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入需求大厅名称', trigger: 'blur' }],
       // longitude: [{ required: true, message: '请输入经度', trigger: 'blur' }, { pattern: /^-?\d+(\.\d{1,6})?$/, message: '经度格式错误(最多保留6位小数)', trigger: 'blur' }],
       // latitude: [{ required: true, message: '请输入纬度', trigger: 'blur' }, { pattern: /^-?\d+(\.\d{1,6})?$/, message: '纬度格式错误(最多保留6位小数)', trigger: 'blur' }],
       // detailed_address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }], // 规则字段名同步修改为 detailed_address
        completion_date: [{ required: true, message: '请选择完成时间', trigger: 'change' }], // 规则字段名同步修改为 completion_date
          // 新增：预算金额验证（必填+数字格式）

        // 新增：联系方式验证（必填）
        contact_information: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.loadRequirementTypes();//初始化时加载需求类型列表
  },
  props: ["open_add"],
  methods: {

     /*获取经纬度*/
      getMapdataFunc(e) {
        this.form.longitude =  e.data[1].toFixed(6), 
        this.form.latitude = e.data[0].toFixed(6), 
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*选择的地址*/
      choseFunc(e){
        console.log("地址",e.location.lat)
        this.form.longitude =  +e.location.lng, 
        this.form.latitude = e.location.lat, 
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;

      },

    // 新增：加载需求类型列表方法
    loadRequirementTypes() {
      Requirement_typeApi.list().then(res => {
        this.requirementTypes = res.data.list.data || [];
      }).catch(err => {
        console.error('加载需求类型失败', err);
        this.$message.error('加载需求类型失败，请稍后重试');
      });
    },

     /*上传 - 新增：根据code区分图片/视频，修改上传配置*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
      // 区分图片/视频的上传配置
      if (code === 'video') {
        this.uploadConfig = { total: 3, accept: 'video/*' }; // 视频：最多传3个，仅接受视频格式
        this.uploadTypeText = '视频'; // 弹窗标题显示“上传视频”
      } else {
        this.uploadConfig = { total: 9, accept: 'image/*' }; // 图片：最多传9个，仅接受图片格式
        this.uploadTypeText = '图片'; // 弹窗标题显示“上传图片”
      }
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      console.log("按钮触发")
      let self = this;
      let form = self.form;

      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Requirement_hallApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传回调 - 复用现有方法，新增video类型判断*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else if(this.code == 'image'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else if(this.code == 'video'){ // 新增：视频处理逻辑
        if (e != null) {
        let videoExpt = ["mp4", "mov", "avi", "flv", "wmv"]; // 常见视频格式
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          videoExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("视频类型有误,请选择mp4/mov/avi/flv/wmv格式");
          return false;
        }

        let videos = this.form.video.concat(e);
        this.$set(this.form, "video", videos); // 将视频数据存入form.video
      }
    }
      
      this.isProductUpload = false;
    },

    /*删除 */
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'image'){
        this.form.image.splice(index, 1);
      }else if(code == 'video'){ //删除视频
        this.form.video.splice(index, 1);
      }
      
    },
   
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/requirement_hall/index/part/add.vue